import type { EntityBatchSyncStatus } from './entityMutationSync'

export type ProductionUnitSyncOutcome = {
  resultLabel: string
}

export const deriveProductionUnitSyncOutcome = (params: {
  status: EntityBatchSyncStatus
  skippedNotFoundCount: number
}): ProductionUnitSyncOutcome => {
  if (params.skippedNotFoundCount > 0) {
    return {
      resultLabel: `Sync skipped ${params.skippedNotFoundCount} missing queued change(s) and continued.`
    }
  }

  if (params.status.blockedCount > 0) {
    if (params.status.errorMessage) {
      return {
        resultLabel: `${params.status.blockedCount} production unit change(s) are blocked: ${params.status.errorMessage}`
      }
    }

    return {
      resultLabel: `${params.status.blockedCount} production unit change(s) are blocked.`
    }
  }

  if (params.status.syncState === 'synced') {
    return { resultLabel: 'Production unit sync is now up to date.' }
  }

  if (params.status.syncState === 'offline') {
    return { resultLabel: 'Still offline. Production unit changes remain queued locally.' }
  }

  return { resultLabel: 'Production unit changes are still pending sync.' }
}
